import { WorkItemStatusString } from '@/apps/dispatcher/types/enums';

// Tables that can be sorted
export const SORTABLE_WORK_ITEM_TABLES = [
  WorkItemStatusString.Done,
  WorkItemStatusString.Projected,
  WorkItemStatusString.Archive,
  WorkItemStatusString.Create,
];

// States that should show the batch editor
export const BATCH_EDITOR_ENABLED_STATES = [
  WorkItemStatusString.Queued,
  WorkItemStatusString.Projected,
  WorkItemStatusString.Done,
  WorkItemStatusString.Archive,
];

// Max number of items allowed in a batch edit
export const BATCH_EDIT_MAX_ITEMS = 100;
export const BATCH_CREATE_MAX_ITEMS = 100;

// Maximum characters allowed in comment input in Wizard
export const INTERNAL_COMMENT_MAX_CHARS = 1024;
export const EXTERNAL_COMMENT_MAX_CHARS = 256;

// Minimum threshold in minutes for projected delays
export const PROJECTED_DELAY_MIN_THRESHOLD = 6;
export const BUS_IS_LATE_MIN_THRESHOLD = 6;

// Defines which fields to render and in which order
export const CHANGELOG_FIELDS = [
  'Status',
  'Schedule.OperationDate',
  'Route.StartingStopName',
  'Schedule.EventFrom',
  'Schedule.EventTo',
  'ReasonId',
  'ReasonCode',
  'InternalComment',
  'ExternalComment',
  'PtaReportId',
  'PtaReportSource',
  'OperatorExempt',
  'Stops',
  'DriverId',
  'VehicleInternalId',
  'Towing.TowingOperator',
  'Towing.TowingCriticality',
  'Route.DepotName',
  'InternalRecipient',
  'DriverReport',
  'DelayInfo.DelaySeconds',
  'DelayInfo.DelayedInRoute',
] as const;

export const CHANGELOG_FIELD_ORDER_MAP = new Map(
  CHANGELOG_FIELDS.map((field, index) => [field, index])
);

type ChangelogFieldName = (typeof CHANGELOG_FIELDS)[number];

// Orders a change set's changes for display: keep only whitelisted fields, in
// CHANGELOG_FIELDS order. A reason edit records both identities in the legacy
// system (numeric ReasonId + LEGACY_* ReasonCode) but only ReasonCode in the
// new system; collapse to a single "Reason" row by dropping the ReasonCode
// entry when a ReasonId entry is present, and keeping it when it is the only
// reason change.
export const orderChangelogChanges = <T extends { fieldName: string }>(
  changes: T[]
): T[] => {
  const hasReasonIdChange = changes.some(
    (change) => change.fieldName === 'ReasonId'
  );

  return changes
    .filter((change) =>
      CHANGELOG_FIELD_ORDER_MAP.has(change.fieldName as ChangelogFieldName)
    )
    .filter(
      (change) => !(hasReasonIdChange && change.fieldName === 'ReasonCode')
    )
    .sort(
      (a, b) =>
        CHANGELOG_FIELD_ORDER_MAP.get(a.fieldName as ChangelogFieldName)! -
        CHANGELOG_FIELD_ORDER_MAP.get(b.fieldName as ChangelogFieldName)!
    );
};
